module.exports = __webpack_public_path__ + "static/media/1 Como comprar-min.c09b7d74.jpg";